<template>
  <van-action-sheet v-model:show="show" title="请选择服务商" @close="close">
    <div class="content">
      <van-list>
        <div class="policy-file-item" v-for="record in list" :key="record" style="border-bottom:1px solid #eee; ">
          <div class="flex" v-if="record.level">
            <div class="img-box">
              <img v-lazy="record.avatar" alt="" v-if="record.avatar" />
              <img src="@/assets/images/mall/img_d.jpg" alt="" v-else />
            </div>
            <div class="flex-item flex policy-file-item-c-b">
              <div class="policy-file-item-content flex-item">
                <div class="policy-file-item-title">
                  <div class="company">
                    {{ record.name }}
                  </div>
                  <div class="title_2">
                   星级：<van-rate gutter="1px"  size="14px"  v-model=" record.level"  readonly />
                  </div>
                  
                </div>
                <div class="browse" v-if="record.click_num">
                  本月浏览量：{{record.click_num}}次
                </div>
              </div>
              <div class="btn-box ">
                <van-button type="primary" @click.stop="declare(record)">使用
                </van-button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- <div class="declare-btn-box">
      <van-button class="declare-btn" type="primary" @click.stop="declareSimple()">
        <img src="@/assets/images/match/btn_declare@2x.png">
        一键申报
      </van-button>
    </div> -->
  </van-action-sheet>
</template>

<script>
export default {
  name: "DeclareModel",
  props: {
    show: false,
    list: [],
  },
  data() {
    return {
      declareSelected: ''
    }
  },

  mounted() {
  },

  methods: {
    declare(item) {
      this.declareSelected = item
      this.$emit('declareSelected', this.declareSelected)
    },
    declareSimple() {
      this.declareSelected = this.list[0]
      this.$emit('declareSelected', this.declareSelected)
    },
    close() {
      this.$emit('closeDeclare')
    }
  }

}
</script>

<style lang="scss" scoped>
.content {
  padding: 16px 16px 16px;
  font-size: 12px;
  overflow: scroll;
  height: 300px;

  .policy-file-item {
    padding: 15px 0 15px 0;
    margin: 0;

    &.has-sider {
      margin-right: 0;
    }
  }

  .img-box {
    width: 73px;
    height: 73px;
    border-radius: 6px;
    position: relative;
    margin-right: 20px;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      background-size: cover;
    }

    .vip-img {
      position: absolute;
      z-index: 10;
      bottom: 0;
      left: -13px;
      width: 25px;
      height: 21px;
      background-size: contain;
      border: 1px solid red;
    }

    .vip-box {
      position: absolute;
      z-index: 5;
      bottom: 0;
      left: 0;
      width: 60px;
      height: 14px;
      background: linear-gradient(88deg, #C99654 0%, #FEE5AF 100%);
      color: #fff;
      text-align: center;
      line-height: 14px;
      padding-left: 13px;

      span {
        color: #FF0000;
        font-size: 14px;
        font-weight: 600;
        margin: 0 3px;
      }
    }
  }

  .policy-file-item-content {
    padding: 0;
    margin: 0;
  }

  .policy-file-item-footer {
    padding: 7px 0 0;

    >div {
      width: 100%;
    }
  }

  .policy-file-item-title {
    font-size: 14px;
  }


}

.declare-btn-box {
  width: 100%;
  text-align: center;
  margin: 20px auto;

  .declare-btn {
    width: 58%;
    height: 45px !important;
      background: linear-gradient(129deg, #1091E8 0%, #1A6FE0 100%);
      img{
        width: 20px;
        height:19px;
        background-size: cover;
        vertical-align: middle;
        margin-right: 6px;
      }
  }
}

.title_2 {
  color: #F59A23;
  margin-top: 5px;
}
.browse{
color: #707070;
margin-top: 5px;
}
.btn-box{
  margin: 0 5px;
}
.policy-file-item-c-b{
  align-items: center;
  justify-content: space-between;
}
</style>
